module.exports = __webpack_public_path__ + "img/img81.4bc186bc.png";